import asyncRender from '@components/async/asyncRender';
import ConfirmDialog from '@components/dialogs/ConfirmDialog';
import { RegionDialog } from '@components/dialogs/RegionDialog';
import NotificationContext from '@context/NotificationContext';
import UserContext from '@context/UserContext';
import Sentry from '@integrations/Sentry';
import IconMoreHoriz from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { deleteDoc,QueryDocumentSnapshot, setDoc } from 'firebase/firestore';
import React, { useContext, useState } from 'react';


type RegionActionsProps = {
  region: QueryDocumentSnapshot<guesthouse.Region>
}

const RegionActions: React.FC<RegionActionsProps> = (props) => {
  const { region } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const notificationContext = useContext<NotificationContext>(NotificationContext);
  const userContext = useContext<UserContext>(UserContext);
  const regionData = region.data();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        edge="end"
        aria-label="actions"
        aria-haspopup="true"
        size="large"
        onClick={handleClick}
      >
        <IconMoreHoriz />
      </IconButton>

      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            asyncRender(RegionDialog, {
              title: 'Edit Region',
              userContext,
              initialValues: regionData,
            })
              .then((result) => setDoc(region.ref, result))
              .then(() => notificationContext.setContext({ open: true, message: 'Succesfully updated region' }))
              .catch((e) => {
                if (e) {
                  Sentry.captureException(e);
                  notificationContext.setContext({ open: true, message: e.message, severity: 'error' });
                }
              });

            handleClose();
          }}
        >
          Edit
        </MenuItem>


        <MenuItem
          onClick={() => {
            asyncRender(ConfirmDialog, {
              title: 'Are you sure you want to delete this region?',
              confirmText: 'Yes, Delete',
            })
              .then(() => deleteDoc(region.ref))
              .then(() => notificationContext.setContext({ open: true, message: 'Succesfully deleted region' }))
              .catch((e) => {
                if (e) {
                  Sentry.captureException(e);
                  notificationContext.setContext({ open: true, message: e.message, severity: 'error' });
                }
              });

            handleClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

export default RegionActions;
